module.exports = __webpack_public_path__ + "static/step-one-fcede37416d4983d7d352008302fb2ce.png";